<template>
  <div class="eu-pt_5">
    <div class="emd-container _highlight_header">
      <div class="emd-container__header">
        <h2 class="emd-text _size_default _type_caption">
          {{ $t('title') }}
        </h2>
      </div>
      <div class="emd-container__content">
        <pre>{{ metadata }}</pre>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Metadata',
  props: {
    metadata: {
      required: true,
      type: Object
    }
  }
}
</script>
<i18n>
      {
        "pt-BR": {
          "title": "Metadado"
        },
        "en-US": {
          "title": "Metadata"
        }
      }
  </i18n>
